export class DataCatalogPipelineResolvedDataset {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "datasetId",
            "baseName": "datasetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogName",
            "baseName": "catalogName",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineResolvedDataset.attributeTypeMap;
    }
    constructor() {
    }
}
